import { OnBoardingStep } from '../../shared/dto/EntityRepository';
import { OnBoardingStepType } from '../../shared/enum/EnumRepository';

// 기본 스텝들 (titleKey는 OnBoardingMessages에서 표시 문구 조회)
export const baseSteps: OnBoardingStep[] = [
  { step: OnBoardingStepType.URL, titleKey: 'STEP_TITLE_PROFILE_URL' },
  { step: OnBoardingStepType.EMAIL, titleKey: 'STEP_TITLE_EMAIL' },
  { step: OnBoardingStepType.ACTIVITY_TYPE, titleKey: 'STEP_TITLE_ACTIVITY_TYPE' },
  // 가입 전 작품 등록 Step은 임시 비활성화. 필요할 때 다시 연결한다.
  // { step: OnBoardingStepType.UPLOAD_WORKS, titleKey: 'STEP_UPLOAD_WORKS' },
  // { step: OnBoardingStepType.WORKS_PREVIEW, titleKey: 'STEP_WORKS_PREVIEW' },
];
// export const baseSteps: OnBoardingStep[] = [
//   { step: OnBoardingStepType.URL, titleKey: 'STEP_TITLE_PROFILE_URL' },
//   { step: OnBoardingStepType.EMAIL, titleKey: 'STEP_TITLE_EMAIL' },
//   { step: OnBoardingStepType.PROJECT_INFO, titleKey: 'STEP_TITLE_PROJECT_INFO' },
//   { step: OnBoardingStepType.PROJECT_WORKS, titleKey: 'STEP_TITLE_WORKS_IN_PROJECT' },
//   { step: OnBoardingStepType.PROJECT_PREVIEW, titleKey: 'STEP_TITLE_PREVIEW' },
// ];
